import { TFactoryState, THeaderResponse, TResponse_ReportMetricColumnConfig } from '@monorepo/types';
import { ActionReducerMap, createSelector } from '@ngrx/store';
import { TAiAnalyticsState } from './ai-analytics/ai-analytics.models';
import { aiAnalyticsReducer } from './ai-analytics/ai-analytics.reducer';
import { factoryReducer } from './factory/factory.reducers';
import { headerReducer } from './header/header.reducers';
import { reportActionReducer } from './reports/adavance-settings/advance-setting.reducer';

export interface IAppState {
  factory: TFactoryState;
  headerInfo: THeaderResponse;
  reports: {
    adavanceMetricSetting: TResponse_ReportMetricColumnConfig;
  };
  aiAnalytics: TAiAnalyticsState;
}

export const reducer: ActionReducerMap<IAppState, never> = {
  factory: factoryReducer,
  headerInfo: headerReducer,
  reports: reportActionReducer,
  aiAnalytics: aiAnalyticsReducer,
};

// Selectors

// Factory Selector
export const selectFactoryInfo = (state: IAppState) => state.factory;
export const selectedFactoryNode = createSelector(selectFactoryInfo, (state) => state.selectedNodeInfo);
export const selectedFactoryNodeLoading = createSelector(selectFactoryInfo, (state) => state.nodeLoading);

// Header Selector
export const selectHeaderInfo = (state: IAppState) => state.headerInfo;

export const selectIsHeaderLoading = createSelector(selectHeaderInfo, (state) => state.isLoading);
